import CreateSubmissionForm from 'components/features/create-submission-form';
import HomeLayout from 'layouts/home-layout';

function CreateSubmission() {
  return (
    <HomeLayout title="Create Submission">
      <CreateSubmissionForm />
    </HomeLayout>
  );
}

export default CreateSubmission;
